export class MappingSectionModel {
	itemid: string;
	time_credit_index: number;
	title: string;
	weight: number;
}
